/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BoxAddIcon = ({ width = 24, height = 24, hidden = false, title = 'Box Add' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m33.408 8.469-5.437-2.947-16.516 9.2L18 18.265l.852-.461a12.255 12.255 0 0 1 4.905-2.657l9.651-5.228a.824.824 0 0 0 0-1.45Zm-3 6.72A12.233 12.233 0 0 1 34 16.893v-3.7ZM2.592 9.919l5.529 3 16.516-9.2L18.762.535a1.6 1.6 0 0 0-1.523 0L2.592 8.469a.824.824 0 0 0 0 1.45ZM16.213 21.09 2 13.193v13.459a1.6 1.6 0 0 0 .823 1.4L16.4 35.594v-2.376a12.259 12.259 0 0 1-.187-12.128ZM27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm5 9.4a.5.5 0 0 1-.5.5H28v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V28h-3.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H26v-3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V26h3.5a.5.5 0 0 1 .5.5Z"
    />
  </svg>`;
};
